"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayOfStringArraysToArrayOfObjects = exports.stringArrayToObject = exports.keyValueObjectToStringArray = void 0;
/**
 * Transforms an array of strings into an object with keys and values.
 * @param array - Array of strings in the format "key:value".
 * @returns Object with keys and values derived from the input strings.
 * @example
 *
 * const userSelection = [
 *   "Format:A3",
 *   "Custom width:29.7",
 *   "Custom height:42",
 *   "Printing Colors:4/4 Full Color",
 *   "Material:Woodfree Coated Glossy Mc",
 *   "Weight:115 Grs",
 *   "Finishing:Without Luxury Finishing",
 *   "Punchholes:No Punchhole",
 *   "Bundling:No Bundling",
 *   "Printing Process:Offset",
 *   "Delivery Type:Normal"
 * ];
 *
 * const resultObject = keyValueObjectToStringArray(userSelection);
 *
 * // Result:
 * // {
 * //   "Format": "A3",
 * //   "Custom width": "29.7",
 * //   "Custom height": "42",
 * //   "Printing Colors": "4/4 Full Color",
 * //   "Material": "Woodfree Coated Glossy Mc",
 * //   "Weight": "115 Grs",
 * //   "Finishing": "Without Luxury Finishing",
 * //   "Punchholes": "No Punchhole",
 * //   "Bundling": "No Bundling",
 * //   "Printing Process": "Offset",
 * //   "Delivery Type": "Normal"
 * // }
 */
function keyValueObjectToStringArray(array) {
  return array.reduce((object, item) => {
    const [key, value] = item.split(/:(.*)/, 2);
    return _objectSpread(_objectSpread({}, object), {}, {
      [key]: value || ''
    });
  }, {});
}
exports.keyValueObjectToStringArray = keyValueObjectToStringArray;
/**
 * @deprecated Use keyValueObjectToStringArray instead.
 */
const stringArrayToObject = keyValueObjectToStringArray;
exports.stringArrayToObject = stringArrayToObject;
/**
 * Transforms an array of string arrays into an array of objects.
 * @param array - Array of string arrays, where each inner array contains strings in the format "key:value".
 * @returns Array of objects with keys and values derived from the input arrays.
 * @example
 *
 * const shippingAddressPerLineItem = [
 *   [
 *     "city:Deventer",
 *     "company:Drukwerkdeal",
 *     "country:NL",
 *     "email:info@drukwerkdeal.nl",
 *     "phone:0888855222",
 *     "postalCode:7418ET",
 *     "streetName:Keulenstraat",
 *     "streetNumber:4",
 *     "quantity:1000"
 *   ]
 * ];
 *
 * const resultArrayOfObjects = arrayOfStringArraysToArrayOfObjects(shippingAddressPerLineItem);
 *
 * // Result:
 * // [
 * //   {
 * //     city: "Deventer",
 * //     company: "Drukwerkdeal",
 * //     country: "NL",
 * //     email: "info@drukwerkdeal.nl",
 * //     phone: "0888855222",
 * //     postalCode: "7418ET",
 * //     streetName: "Keulenstraat",
 * //     streetNumber: "4",
 * //     quantity: "1000"
 * //   }
 * // ]
 */
function arrayOfStringArraysToArrayOfObjects(array) {
  return array.map(keyValueObjectToStringArray);
}
exports.arrayOfStringArraysToArrayOfObjects = arrayOfStringArraysToArrayOfObjects;